const stateMap = new Map<string, { state: string }>([
  ['draft', { state: 'Draft' }],
  ['submitted', { state: 'Submitted' }],
  ['caseWorkerAssigned', { state: 'Assigned' }],
  ['revisionRequested', { state: 'Revision Requested' }],
  ['revisionSubmitted', { state: 'Revision Submitted' }],
  ['decisionRendered', { state: 'Decision Rendered' }]
]);

export function getStateDescription(record: string): string | undefined {
  if (!record) {
    throw new Error('Invalid state provided');
  }
  const stateObject = stateMap.get(record);
  return stateObject?.state;
}
